<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="160px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="提成会员" prop="name">
              <el-input  v-model="name" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="报考学生手机号" prop="mobile">
               <el-autocomplete
                  class="inline-input"
                  v-model="formParameter.mobile"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入手机号"
                 
                ></el-autocomplete>

              <el-tag v-for="(v, i) in parameter" :key="i">
                {{ v.name }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="金额合计">
                {{  formParameter.costAll}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提成次数" prop="type">
              <el-radio v-model="radio" label="1">一次</el-radio>
              <el-radio v-model="radio" label="2">两次</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="支付金额1" prop="cost1"><el-input v-model="formParameter.cost1"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="应付时间1" prop="tctm">
              <el-date-picker v-model="formParameter.tctm1" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="支付时间1" prop="paydate">
              <el-date-picker v-model="formParameter.paydate1" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注1" prop="remark"><el-input v-model="formParameter.remark1"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="radio == 2">
          <el-col :span="24">
            <el-form-item label="支付金额2" prop="cost2"><el-input v-model="formParameter.cost2"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="radio == 2">
          <el-col :span="12">
            <el-form-item label="应付时间2" prop="tctm">
              <el-date-picker v-model="formParameter.tctm2" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付时间2" prop="paydate">
              <el-date-picker v-model="formParameter.paydate2" type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="radio == 2">
          <el-col :span="24">
            <el-form-item label="备注2" prop="remark"><el-input v-model="formParameter.remark2"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">添 加</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/xueli/ticheng.js";
import apiStu from "@/api/xueli/xlstudent.js";
export default {
  name: "add",
  components: {
    popup,
  },
  watch: {
    "formParameter.cost1": {
      handler() {
        if (this.formParameter.cost1) {
          this.formParameter.costAll =
            this.formParameter.cost1 * 1 +
            (this.formParameter.cost2 ? this.formParameter.cost2 * 1 : 0);
        }
      },
    },
    "formParameter.cost2": {
      handler() {
        // console.log(this.formParameter)
        if (this.formParameter.cost2) {
          this.formParameter.costAll =
            (this.formParameter.cost1 ? this.formParameter.cost1 * 1 : 0) +
            this.formParameter.cost2 * 1;
        }
      },
    },
  },
  data() {
    return {
      disabled: false,
      radio: "1",
      popupLoading: false,
      confirmLoading: false,
      parameter: [],
      formParameter: {},
      stuObj: false,
      results: [],
      stuList:[],//会员备选列表
      name: '',//提成人
    };
  },
  methods: {
    //根据输入发起查询
    querySearch(queryString, cb) {
      //发起异步
      api.findByName({mobile:queryString},res=>{
        res.data[0]
        this.name = res.data[0].name
        this.formParameter.name = res.data[0].name
        this.formParameter.id = res.data[0].id
        this.formParameter.pid = res.data[0].pid
        this.formParameter.stuid = res.data[0].stuid
        var results = queryString ? stuList.filter(this.createFilter(queryString)) : stuList;
        // 调用 callback 返回建议列表的数据
        cb(results)
      })
        
      },
      loadAll() {
        return this.stuList
      },
      // handleSelect(item) {
      //   console.log(item)
      //   this.name = item.name
      // },

    

    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      //console.log(parameter);
      this.disabled = disabled;
      this.$refs.popup.open(title, "40%");
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.name=''
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.confirmLoading = true;
      this.formParameter.stuids = [];
      if (this.stuObj) {
        this.formParameter.stuids.push(this.stuObj.id)
      } else {
        this.parameter.forEach((v) => this.formParameter.stuids.push(v.id));
      }

      //删除属性
      delete this.formParameter.costAll;

      //编辑
      let parameter = this.$utils.merger(this.formParameter);

      //console.log(parameter);
      api.save(
        parameter,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.confirmLoading = false;
          this.close();
          this.$parent.list();
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      );
    },
    init() {
      //this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();
      this.stuList = this.loadAll();
    


// if (this.parameter.id) {
//         //编辑查询数据
//         let parameter = {
//           id: this.parameter.id,
//         };
//         api.toUpdate(parameter, (response) => {
//           this.formParameter = response.data;
//           this.popupLoading = false;
//         });
//       } else {
//         //添加
//         this.popupLoading = false;
//       }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
